import type { GordianSeat } from "@b2bportal/air-seats-api";
import type { GordianSeatSegment } from "@hopper-b2b/types";
import type { HopperSeatTotal } from "./context";

export enum SeatEventTypes {
  CLEAR_SEAT_ERROR = "CLEAR_SEAT_ERROR",
  SELECT_SEATS = "SELECT_SEATS",
  SKIP_SEAT_SELECTION = "SKIP_SEAT_SELECTION",
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
  SET_SEATS_CONTEXT = "SET_SEATS_CONTEXT",
}

export interface ClearSeatError {
  type: SeatEventTypes.CLEAR_SEAT_ERROR;
}

export interface SelectSeat {
  type: SeatEventTypes.SELECT_SEATS;
  seats: Array<GordianSeat>;
  seatSegments: Array<GordianSeatSegment>;
  selectedSeatTotal?: HopperSeatTotal;
}

export interface SkipSeatSelection {
  type: SeatEventTypes.SKIP_SEAT_SELECTION;
}

export interface SeatSelectionNextEvent {
  type: SeatEventTypes.NEXT;
}

export interface SeatSelectionPreviousEvent {
  type: SeatEventTypes.PREVIOUS;
}

export interface SetSeatsContext {
  type: SeatEventTypes.SET_SEATS_CONTEXT;
}

export type SeatEvents =
  | ClearSeatError
  | SelectSeat
  | SetSeatsContext
  | SkipSeatSelection
  | SeatSelectionNextEvent
  | SeatSelectionPreviousEvent;
